import { render, staticRenderFns } from "./SkeletonTasks.vue?vue&type=template&id=4a29f8f6&scoped=true&"
import script from "./SkeletonTasks.vue?vue&type=script&lang=js&"
export * from "./SkeletonTasks.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonTasks.vue?vue&type=style&index=0&id=4a29f8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a29f8f6",
  null
  
)

component.options.__file = "SkeletonTasks.vue"
export default component.exports